import { IPitch } from "../types";

export const getNoteOffset = (offset: number): IPitch => {
  switch (offset) {
      case 0:
          return { s: 1, a: 0 };
      case 1:
          return { s: 1, a: 1 };
      case 2:
          return { s: 3, a: 0 };
      case 3:
          return { s: 3, a: 1 };
      case 4:
          return { s: 5, a: 0 };
      case 5:
          return { s: 0, a: 0 };
      case 6:
          return { s: 0, a: 1 };
      case 7:
          return { s: 2, a: 0 };
      case 8:
          return { s: 2, a: 1 };
      case 9:
          return { s: 4, a: 0 };
      case 10:
          return { s: 6, a: -1 };
      case 11:
          return { s: 6, a: 0 };
      default:
          return { s: 0, a: 0 };
  }
};